import { render } from "./BorrowerBadge.vue?vue&type=template&id=bc81f878&scoped=true"
import script from "./BorrowerBadge.vue?vue&type=script&lang=js"
export * from "./BorrowerBadge.vue?vue&type=script&lang=js"

import "./BorrowerBadge.vue?vue&type=style&index=0&id=bc81f878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc81f878"]])

export default __exports__